import {FC} from 'react'
import {OffersTypesListWrapper} from '../../modules/offers types/OfferTypesList'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
const offerTypesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Offer Type Management',
    path: '/offers-types',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const OfferTypesWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={offerTypesBreadcrumbs}>Offer Types list</PageTitle>
      <OffersTypesListWrapper />
    </>
  )
}

export {OfferTypesWrapper}
